// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"296":"privacy","443":"about"}[chunkId] + "-legacy." + {"296":"b34c6c71","443":"34d68fe2"}[chunkId] + ".js";
};